<template>
  <div>
    <vueCustomScrollbar class="list-scroll">
      <b-table striped hover :fields="fieldsTableMember" :items="listData">
        <template #head(stt)="data">
          <span class="col-table">{{ data.label }}</span>
        </template>
        <template #head(name)="data">
          <span class="col-table">{{ data.label }}</span>
        </template>
        <template #cell(stt)="row">
          {{ row.item.stt }}
        </template>
        <template #cell(lessonName)="row">
          {{ row.item.lessonName }}
        </template>
        <template #cell(completeRate)="row">
          {{ row.item.completeRate != null ? formatCompleteRate(row.item.completeRate) + '%' : '-' }}
        </template>
        <template #cell(point)="row">
          {{ formatNumber(row.item.point) }}
        </template>
        <template #cell(completeDate)="row">
          {{ row.item.completeDate != null ? moment(row.item.completeDate).format('DD/MM/YYYY - HH:mm') : '-' }}
        </template>
        <template #table-caption v-if="listData.length == 0">Chưa có dữ liệu lịch sử bài tập bài kiểm tra</template>
      </b-table>
    </vueCustomScrollbar>
    <div class="row pagination container m-0 mb-3">
      <b-pagination pills v-model="paramQueryData.pageIndex" :total-rows="totalRecords"
        :per-page="paramQueryData.pageSize" first-number last-number>
      </b-pagination>
    </div>
  </div>
</template>
<script>

import moment from "moment"
import { getListExcerice } from './../../_api/lessonClassSchoolUserServices';
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    vueCustomScrollbar
  },
  props: {
    userId: {
      type: String,
      default: '0'
    },
    classSchoolId: {
      type: String,
      default: '0'
    },
  },
  watch: {
    'userId': 'getListExcericeByUserId',
    'paramQueryData.pageIndex': 'getListExcericeByUserId',
  },
  data() {
    return {
      paramQueryData: {
        keyword: '',
        pageIndex: 1,
        pageSize: 8,
        userId: 0,
        classSchoolId: 0,
        isGetByAll: true
      },
      fieldsTableMember: [
        { key: 'stt', label: 'STT', thClass: 'w-100px text-center', tdClass: 'w-100px text-center' },
        { key: 'lessonName', label: 'Tên bài tập/bài kiểm tra', thClass: 'm-w-200px w-200px', tdClass: 'm-w-200px w-200px' },
        { key: 'completeRate', label: 'Tiến độ hoàn thành', thClass: 'w-180px text-center', tdClass: 'w-180px text-center' },
        { key: 'point', label: 'Điểm số', thClass: 'w-150px text-center', tdClass: 'w-150px text-center' },
        { key: 'completeDate', label: 'Thời gian hoàn thành', thClass: 'w-180px text-center', tdClass: 'w-180px text-center' }
      ],
      listData: [],
      totalRecords: 0
    };
  },
  mounted() {
    if (this.userId * 1 > 0) {
      this.getListExcericeByUserId()
    }
  },
  methods: {
    moment,
    formatNumber(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return value.toFixed(2);
    },
    formatCompleteRate(value) {
      if (typeof value !== 'number') {
        return value;
      }
      return Number(value.toFixed(2));
    },
    getListExcericeByUserId() {
      this.listData = []
      this.paramQueryData.userId = this.userId * 1
      this.paramQueryData.classSchoolId = this.classSchoolId * 1
      getListExcerice(this.paramQueryData).then(res => {
        if (res && res.data && !res.errors && res.data.list != null) {
          for (let i = 0; i < res.data.list.length; i++) {
            const item = res.data.list[i];
            const coefficient = (this.paramQueryData.pageIndex - 1) * this.paramQueryData.pageSize
            this.listData.push({
              'stt': coefficient + i + 1,
              'lessonName': item.lessonName,
              'classSchoolName': item.classSchoolName,
              'classSchoolId': this.classSchoolId,
              'subjectName': item.subjectName,
              'completeRate': (item.completeRate == 0 ? ((item.countAnswer || 0) / (item.countQuestion || 1) * 100).toFixed(2) : item.completeRate.toFixed(2)),
              'point': item.point,
              'completeDate': item.completeDate,
              'countQuestion': item.countQuestion,
              'countAnswer': item.countAnswer,
            })
          }
          this.totalRecords = res.data.paging.totalRecords
        }
      })
    }
  }

};
</script>

<style lang="scss" scoped>
.list-scroll {
  max-height: calc(60vh - 5rem);
  overflow-y: auto;
}
</style>